import React, {useState} from 'react';
import ProjectsCheckboxPanel from '../../Components/Projects/ProjectsCheckboxPanel';
import ProjectsGalleryItem from '../../Components/Projects/ProjectsGallery';
import ImagesPopup from '../../Components/ImagesPopup';
import {PERMISSIONS} from '../../../helpers/constants';
import {useSelector} from 'react-redux';

const ProjectReportsItem = ({
  array,
  checkedItems,
  handleCheckAll,
  isCheckAll,
  handleCheck,
  type,
  deleteReportHandler,
  deleteReportMultiple,
  reportsDownload
}) => {
  const {profileMe} = useSelector((state) => state.profile);

  const [popupView, setPopupView] = useState({
    files: [],
    type: 'photo',
    index: 0,
    visible: false
  });
  const getUniqueCreatorsAndDates = (array) => {
    const result = [];

    array.forEach((item) => {
      const date = new Date(item.created_at).toISOString().split('T')[0];
      const creatorId = item.creator.id;

      const existingEntry = result.find((entry) => entry.creator.id === creatorId && entry.date === date);

      if (!existingEntry) {
        result.push({
          creator: item.creator,
          date: date,
          items: [item]
        });
      } else {
        existingEntry.items.push(item);
      }
    });

    result.sort((a, b) => new Date(b.date) - new Date(a.date));

    return result;
  };

  const groupedArray = getUniqueCreatorsAndDates(array);

  return (
    <>
      <ProjectsCheckboxPanel
        checkedItems={checkedItems[type]}
        handleCheckAll={() => handleCheckAll(type)}
        isCheckAll={isCheckAll[type]}
        deleteReportMultiple={deleteReportMultiple}
        type={type}
        permissionTrash={PERMISSIONS.REMOVE_REPORTS}
        permissionDownload={PERMISSIONS.REPORT_DOWNLOAD}
        permissions={profileMe?.permissions ?? []}
        reportsDownload={reportsDownload}
      />
      <div className='projects__gallery-scrollable'>
        {groupedArray.map((el, key) => {
          return (
            <ProjectsGalleryItem
              el={el.items}
              date={el.date}
              creator={el.creator}
              type={type}
              key={key}
              array={groupedArray}
              checkedItems={checkedItems[type]}
              handleCheck={(id) => handleCheck(type, id)}
              deleteReportHandler={deleteReportHandler}
              setPopupView={setPopupView}
              permissionTrash={PERMISSIONS.REMOVE_REPORTS}
              permissionDownload={PERMISSIONS.REPORT_DOWNLOAD}
              permissions={profileMe?.permissions ?? []}
            />
          );
        })}
      </div>
      <ImagesPopup popupView={popupView} setPopupView={setPopupView} />
    </>
  );
};

export default ProjectReportsItem;
